module.exports = __webpack_public_path__ + "static/media/iconmonstr-linkedin-4.4eec9da2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/iconmonstr-linkedin-4.svg
// module id = 238
// module chunks = 0